const mapCategoriesToCategoryIds = (items) =>
  items.map(({ categoryId }) => categoryId).filter(Boolean);

export default mapCategoriesToCategoryIds;
